import { HNCoreFrontendWebForside } from '../types/Resources';

import Loader from '@helsenorge/designsystem-react/components/Loader';
import Title from '@helsenorge/designsystem-react/components/Title';
import designsystemtypography from '@helsenorge/designsystem-react/scss/typography.module.scss';

import useResources from '@helsenorge/framework-utils/resources/useResources';

import Projects from '../constants/projects';
import { getResources } from '../resources';
import nbResources from '../resources/HN.CoreFrontend.Web.Forside.nb-NO.json';

import styles from './styles.module.scss';

const UtloggetFraOIDC: React.FunctionComponent = () => {
  const resources = useResources<HNCoreFrontendWebForside>(Projects.Forside, getResources);

  if (!resources) {
    return <Loader overlay="screen" size={'medium'} />;
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
          <div className={styles.utlogget}>
            <Title htmlMarkup="h1" appearance="title1">
              {resources.signedOut_SignedOut_Title || nbResources.signedOut_SignedOut_Title}
            </Title>

            <p className={designsystemtypography.preamble}>
              {resources.signedOut_SignedOut_Explanation || nbResources.signedOut_SignedOut_Explanation}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default UtloggetFraOIDC;
